import { Input } from "@/components/ui/input";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export function SearchBar({ value, onChange }: SearchBarProps) {
  return (
    <div className="relative animate-fade-in-up stagger-1">
      <svg
        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
      </svg>
      <Input
        type="text"
        placeholder="Найти рецепт..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10 h-11 bg-card border-border/60 focus-visible:ring-primary/30 transition-all duration-200 placeholder:text-muted-foreground/60"
        style={{ fontFamily: "var(--font-body)" }}
      />
    </div>
  );
}
